import get from "lodash.get"

/**
 * Built-in filter for getting entity out of relationship
 * @param	field.entity:
 * 	getEntityFromRelationship: {
 * 		whichRelationships: "case.holder.relationships",
 * 		caseFactTypeAsRefId: "contactPersonRelationshipId"
 * 	}
 * @returns entity object from store
 */

const getEntityFromRelationship = (field, ctx) => {
	const {
		whichRelationships,
		caseFactTypeAsRefId
	} = field?.entity?.getEntityFromRelationship

	// Find relationships array based on whichRelationships
	const relationships = get(
		ctx.$store.state.caseManagement,
		whichRelationships,
		[]
	)

	// Find relationshipId in case facts
	const relationshipId = ctx.$store.state.caseManagement.case.facts.find(
		fact => fact?.type === caseFactTypeAsRefId
	)?.value?.stringValue

	// Find concerned entity in list of relationships based on relationshipId
	const concernedEntity = relationships?.find(
		relationship => relationship?.id === relationshipId
	)?.entity

	// Check if we have to to go into concernedEntity.relationships
	// It's determined by key continue
	if (field?.entity?.getEntityFromRelationship?.continue) {
		// Find relationshipId in case facts
		const {
			caseFactTypeAsRefId
		} = field?.entity?.getEntityFromRelationship?.continue

		const relationship2Id = ctx.$store.state.caseManagement.case.facts.find(
			fact => fact.type === caseFactTypeAsRefId
		)?.value?.stringValue

		// Get entity from that found relationship from concernedEntity
		const concernedConcernedEntity = concernedEntity?.relationships?.find(
			r => r.id === relationship2Id
		)?.entity

		return concernedConcernedEntity
	}

	// HACK delete console
	console.log(
		"getEntityFromRelationship",
		relationships,
		relationshipId,
		concernedEntity
	)

	return concernedEntity
}

/**
 *
 */
const getRelationFromEntityFromRelationship = (field, ctx) => {
	const { fieldOfEntityFromRelationship } = field?.relation
	const concernedEntity = getEntityFromRelationship(field, ctx)

	console.log(
		"getRelationFromEntityFromRelationship",
		concernedEntity?.[field?.relation?.fieldOfEntityFromRelationship]
	)

	return concernedEntity?.[field?.relation?.fieldOfEntityFromRelationship] || []
}

/**
 * Helper function to get data based on field
 * If field is a function, it will invoke it and return the value
 * If field is a string, we assume it's a dot notation
 * If field is an object, we are checking for special keys for built-in filters, if no found, return the object
 */
const getFieldData = (fieldName, field, ctx) => {
	// If fieldName is a function, call it with proper context
	if (typeof field?.[fieldName] === "function") {
		// console.clear()
		console.log("It's function", field)
		console.log("fn invoked", field?.[fieldName]?.call(ctx))
		return field?.[fieldName]?.call(ctx)
	}

	// If fieldName is a string, we assume it is a dot notation and we access data via get
	if (typeof field?.[fieldName] === "string") {
		// console.clear()
		// console.log("It's string", field, fieldName)
		return get(ctx.$store.state.caseManagement, field?.[fieldName], null)
	}

	// Otherwise we assume it's an object

	// Check for special keys for built-in filters
	console.log("It's object", field, fieldName)
	if (fieldName === "entity" && field?.entity?.getEntityFromRelationship) {
		console.log("getEntityFromRelationship")
		return getEntityFromRelationship(field, ctx)
	}

	if (
		fieldName === "relation" &&
		field?.relation?.fieldOfEntityFromRelationship
	) {
		console.log("getRelationFromEntityFromRelationship")
		return getRelationFromEntityFromRelationship(field, ctx)
	}

	// If no filtering, return the object
	return field?.[fieldName]
}

/**
 * Function that will help to decide if field should be suggested (in the list when user is picking e.g. facts)
 * It is based on suggest options passed in field schema and `type` of item in the list of things user is picking
 * There is a few options in schema how we can suggest a field e.g. based on includes or based on equals
 * @param {object} item - item of the list user is picking from, item has `type` property we are interested in
 * @returns `true` if it should be suggested, otherwise `false`
 *
 */
const shouldSuggest = (item, suggest) => {
	if (!suggest || !item) return false

	// If typeIs
	if (suggest?.typeIs) return item?.type === suggest.typeIs

	// If typeIncludes
	if (suggest?.typeIncludes) return item?.type?.includes(suggest?.typeIncludes)

	return false
}

export { getFieldData, shouldSuggest }
